import React from 'react';
import Images from "./Images/Images.tsx";
import Videos from "./Videos/Videos.tsx";
import Files from "./Files/Files.tsx";
import TextComponents from "./TextComponents/TextComponents.tsx";
import Links from "./Links/Links.tsx";
import Audios from "./Audio/Audios.tsx";

interface EditAreaProps {
    editedContent: any[];
    setEditedContent: any;
}

const EditArea: React.FC<EditAreaProps> = ({ editedContent, setEditedContent }) => {
    const videos = editedContent.filter((item: any) => item.type === "video");
    const images = editedContent.filter((item: any) => item.type === "image");
    const audios = editedContent.filter((item: any) => item.type === "audio");
    const files = editedContent.filter((item: any) => item.type === "file");
    const links = editedContent.filter((item: any) => item.type === "link");
    const texts = editedContent.filter((item: any) => item.type === "text");

    return (
        <>
            <Videos
                offset={0}
                editedContent={editedContent}
                setEditedContent={setEditedContent}
                iterObject={videos}
                isEditing={true}
            />
            <Images
                offset={videos.length}
                editedContent={editedContent}
                setEditedContent={setEditedContent}
                iterObject={images}
                isEditing={true}
            />
            <Audios
                offset={videos.length + images.length}
                editedContent={editedContent}
                setEditedContent={setEditedContent}
                iterObject={audios}
                isEditing={true}
            />
            <Files
                offset={videos.length + images.length + audios.length}
                editedContent={editedContent}
                setEditedContent={setEditedContent}
                iterObject={files}
                isEditing={true}
            />
            <Links
                offset={videos.length + images.length + audios.length + files.length}
                editedContent={editedContent}
                setEditedContent={setEditedContent}
                iterObject={links}
                isEditing={true}
                role={null}
            />
            <TextComponents
                offset={videos.length + images.length + audios.length + files.length + links.length}
                editedContent={editedContent}
                setEditedContent={setEditedContent}
                iterObject={texts}
                isEditing={true}
            />
        </>
    );
};

export default EditArea;